<template>
  <div>
    <div class="colspan"
         id="dynamicsRC">
      <div class="top clearfix">
        <p class="p1 clearfix">
          <i class="el-icon-s-order"></i>
          {{title}}
        </p>
      </div>
      <div class="content">
        <ul>
          <li v-for="item in infoList"
              :key="'aa'+item.id"
              @click="goto(item,item.id)">
            <p :title="item.title">{{item.title}}</p>
            <span>{{$dateToConver(item.publish_at)}}</span>
          </li>
        </ul>
      </div>
      <div class="page">
        <el-pagination background
                       @current-change="handleCurrentChange"
                       :current-page.sync="page"
                       layout="prev, pager, next"
                       :page-size="page_size"
                       :total="total"
                       :hide-on-single-page="true"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import merge from "webpack-merge"
export default {
  data () {
    return {
      infoList: [],
      title: "",
      page: 1,
      page_size: 10,
      total: 0,
      cate_id: null,
      id: null, //导航id
      second_navId: null //二级导航
    };
  },
  methods: {
    goto (item, id) {
      if (item.type == 4) {
        this.channelGoto(item)
        return false
      }
      if (this.second_navId) {
        this.$router.push({
          name: "details",
          query: { id: this.id, second_navId: this.second_navId, newsId: id }
        });
      } else {
        this.$router.push({
          name: "details",
          query: { id: this.id, newsId: id }
        });
      }
    },
    prev () { },

    //点击下一页和点击页码时执行
    handleCurrentChange (val) {
      this.pageSync(val);
      this.getPageData();
    },
    getPageData () {
      let that = this;
      this.$db
        .get(
          this.$url.document.list +
          "?page=" +
          this.page +
          "&page_size=" +
          this.page_size +
          this.cate_id
        )
        .then(res => {
          that.infoList = res.data.data;
          that.total = res.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCateValue (channelId) {
      let that = this;
      that.$db
        .get(this.$url.channel.url + "/" + channelId)
        .then(res => {
          that.title = res.data.title;
          return res.data.value.split(",");
        })
        .then(result => {
          if (result) {
            let value = "";
            result.forEach((item, index) => {
              let str = "&cate_id[" + index + "]=" + item;
              value += str;
            });
            this.cate_id = value;
            that.getPageData();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    pageSync (val) {
      let query = this.$route.query;
      this.$router.push({
        query: merge(this.$route.query, { 'page': val })
      });
    }
  },
  created () {
    this.id = this.$route.query.id;
    let that = this;
    this.second_navId = this.$route.query.second_navId;
    let id = this.second_navId ? this.second_navId : this.id;
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page);
    }
    else {
      this.page = 1;
      this.pageSync(1);
    }
    //接口导航ID 1,根据导航ID 查找这个导航绑定大分类
    that.$db
      .get(this.$url.channel.url + "/" + id)
      .then(res => {
        that.title = res.data.title;
        return res.data.value.split(",");
      })
      .then(result => {
        if (result) {
          let value = "";
          result.forEach((item, index) => {
            let str = "&cate_id[" + index + "]=" + item;
            value += str;
          });
          this.cate_id = value;
          that.getPageData();
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  watch: {
    "$route.query.id": function (value) {
      if (value) {
        this.id = value;
        this.page = 1;
        this.getCateValue(value);
      }
    },
    "$route.query.second_navId": function (value) {
      if (value) {
        this.second_navId = value;
        this.page = 1;
        this.getCateValue(value);
      } else if (typeof value == "undefined") {
        this.getCateValue(this.id);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.colspan {
  width: 950px;
  overflow: hidden;
  background-color: #ffffff;
  border: solid 1px #e5e5e5;
  box-sizing: border-box;
  > .top {
    > .p1 {
      margin: 0;
      float: left;
      margin-left: 12px;
      font-size: 20px;
      height: 26px;
      border-top: 2px solid #fff;
      padding-top: 20px;
    }
  }
  > .content {
    min-height: 500px;
    > ul {
      list-style-type: none;
      padding: 0;
      > li {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px dashed #ccc;
        color: #404040;
        font-size: 16px;
        margin: 0 30px;
        cursor: pointer;
        > p {
          float: left;
          margin: 0;
          width: 600px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        > span {
          float: right;
          color: #888;
        }
      }
    }
  }
  > .page {
    float: left;
    overflow: hidden;
    margin-left: 50%;
    margin-top: 20px;
    height: 100px;
    line-height: 100px;
    transform: translateX(-50%);
  }
  .page /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    color: #fff;
  }
  .page /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ea373b;
  }
  .page /deep/ .el-pagination.is-background .el-pager li:hover {
    color: #ea373b;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dynamics/rightContent.vue